import { render, staticRenderFns } from "./FlawView.vue?vue&type=template&id=fd80cbfe&scoped=true"
import script from "./FlawView.vue?vue&type=script&lang=js"
export * from "./FlawView.vue?vue&type=script&lang=js"
import style0 from "./FlawView.vue?vue&type=style&index=0&id=fd80cbfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd80cbfe",
  null
  
)

export default component.exports